import { Box, Tooltip, Typography } from "@mui/material";
import TruncateTooltip from "@/components/truncate-with-tooltip";
import GridActionPopover from "@/components/page-header/grid-actions-popover";
import { useEffect, useRef, useState } from "react";
import UIPopper from "../popover";
import AvatarDefault from "../avatar";
import { colorEnums } from "@/modules/crm/dashboard/helper";
import ShowMorePopper from "./show-more-popper";
import { useSelector } from "react-redux";
import { getCalendars } from "@/store/slices/appointment/appointmentSlice";

const commonStyles = {
  width: 18,
  height: 18,
  minWidth: 10,
  minHeight: 10,
  fontSize: "0.7rem",
};
export const Event = ({
  event,
  contextMenuOptions = null,
  onHover = false,
  popOverComp = () => {},
  onEventClick,
  showAvatar = false,
  showContextMenu,
  onSelectEvent,
}) => {
  const calendars = useSelector(getCalendars) || [];
  const resolvedCalendar = calendars.find(
    (c) => c.uuid === event?.calendarId || c.calendarId === event?.calendarId
  );
  const hostMember = resolvedCalendar?.members?.find(
    (m) =>
      m.id === event?.participantId ||
      m.id === event?.memberId ||
      m.memberId === event?.participantId ||
      m.memberId === event?.memberId ||
      m.userId === event?.participantId ||
      m.userId === event?.memberId
  );
  const hostName = hostMember?.name || resolvedCalendar?.members?.[0]?.name || event?.organizer || "N/A";
  const guestName = event?.name || event?.guest || event?.email || "N/A";
  const divRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const hiddenEvents = event._overlaps || [];

  const handleMouseEnter = (event) => {
    console.log("enter");
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    console.log("leave");
    setAnchorEl(null);
  };

  useEffect(() => {
    if (divRef.current) {
      setWidth(divRef.current.offsetWidth);
      setHeight(divRef.current.offsetHeight);
    }
  }, []);

  const tooltipAvatar = (comp) => (
    <Tooltip
      arrow
      title={
        <Box>
          <Typography
            sx={{ fontSize: "0.9rem", fontWeight: "600" }}
            color={"primary"}
          >
            Host:{" "}
            <Typography
              component={"span"}
              sx={{ fontSize: "0.8rem", color: "var(--palette-grey_text)" }}
            >
              {hostName}
            </Typography>
          </Typography>
          <Typography
            sx={{ fontSize: "0.9rem", fontWeight: "600" }}
            color={"primary"}
          >
            Guest:{" "}
            <Typography
              component={"span"}
              sx={{ fontSize: "0.8rem", color: "var(--palette-grey_text)" }}
            >
              {guestName}
            </Typography>
          </Typography>
        </Box>
      }
      placement="top-start"
      PopperProps={{
        sx: {
          "& .MuiTooltip-tooltip": {
            maxWidth: 170,
          },
        },
      }}
    >
      {comp}
    </Tooltip>
  );

  return (
    <Box
      ref={divRef}
      className="d-flex align-items-center justify-content-space-between"
      sx={{ height: "100%", margin: "auto 1px" }}
    >
      <Box
        className="d-flex align-items-center justify-content-space-between"
        sx={{
          px: height <= 25 ? "" : "5px",
          width: "100%",
          backgroundColor: event?.color?.code || "#BCAAFF",
          borderRadius: "5px",
          // color: "#281A66",
          color: event?.color?.textCode || "var(--palette-primary_button)",
          // border: "1px solid #A085FE",
          px: "5px",
        }}
        // sx={{ minHeight: "40px" }}
        // aria-hidden="false"
        // onMouseLeave={handleMouseLeave}
      >
        {onHover ? (
          <PopoverComp popOverComp={popOverComp} event={event} />
        ) : (
          <Box
            {...(onEventClick
              ? { onClick: () => onEventClick(event, "event-clicked") }
              : {})}
          >
            <Box className="d-flex">
              <TruncateTooltip
                limit={width && width < 100 ? 8 : 10}
                text={event?.title}
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: 500,
                  display: "block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              />
            </Box>
          </Box>
        )}
        <Box className="d-flex align-items-center" sx={{ gap: "4px", flexShrink: 0 }}>
          
          {showAvatar &&
            !event?.isBusy &&
            tooltipAvatar(
              <Box
                className="d-flex align-items-center"
                style={{ position: "relative", width: "26px", height: "18px" }}
              >
                <AvatarDefault
                  name={hostName}
                  avatarStyles={{
                    ...commonStyles,
                    background: colorEnums.green.text,
                    color: colorEnums.green.bg,
                  }}
                />
                <AvatarDefault
                  name={guestName}
                  avatarStyles={{
                    ...commonStyles,
                    background: colorEnums.purple.text,
                    color: colorEnums.purple.bg,
                    position: "absolute",
                    right: 0,
                  }}
                />
              </Box>,
          )}

          {contextMenuOptions && showContextMenu && !event?.isBusy && (
            <GridActionPopover
              clickNodeStyles={{
                background: event?.color?.code || "none",
                color: event?.color?.textCode || "var(--palette-primary_button)",
                padding: 0,
                fontSize: "1rem",
                "&:hover": {
                  backgroundColor: "none",
                },
              }}
              options={contextMenuOptions(event)}
            />
          )}
        </Box>
      </Box>
      {hiddenEvents.length ? (
        <ShowMorePopper
          clickNodeSX={{
            minWidth: "max-content",
            fontSize: "0.8rem",
            fontWeight: "600",
            padding: "2px 5px",
            margin: "1px",
          }}
          title={`+${hiddenEvents.length} more`}
          events={hiddenEvents}
          contextMenuOptions={contextMenuOptions}
          popOverComp={popOverComp}
          onHover={onHover}
          onSelectEvent={onSelectEvent}
        />
      ) : null}
    </Box>
  );
};

export const customEventStyling = (event, start, end, isSelected) => {
  // var backgroundColor = '#' + event.hexColor;
  var style = {
    backgroundColor: event?.color?.code || "#BCAAFF",
    borderRadius: "5px",
    // color: "#281A66",
    color: event?.color?.textCode || "var(--palette-primary_button)",
    // border: "1px solid #A085FE",
  };
  return {
    style: style,
  };
};

export const PopoverComp = ({ popOverComp, event }) => {
  return (
    <div style={{ cursor: "pointer" }}>
      <UIPopper
        paperStyles={{ p: 1 }}
        anchorOrigin={{ vertical: "center", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        paperClasses=""
        clickNode={<span>{event.title}</span>}
      >
        {({ setAnchorEl }) => {
          return <Box>{popOverComp({ event, setAnchorEl })}</Box>;
        }}
      </UIPopper>
    </div>
  );
};
